import React from 'react'
import Modal, { ModalBody, ModalFooter, ModalHeader } from 'core-system/Modal'
import PrimaryButton from 'core-system/Button/PrimaryButton'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import Text from 'core-system/Text'

interface ApproveEligibleReimbursementsModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
}

const ApproveEligibleReimbursementsModal = React.memo(
  ({ open, onClose, onConfirm }: ApproveEligibleReimbursementsModalProps) => {
    const [submitting, setSubmitting] = React.useState(false)

    const handleConfirm = async () => {
      setSubmitting(true)
      try {
        await onConfirm()
        onClose()
      } finally {
        setSubmitting(false)
      }
    }

    return (
      <Modal
        open={open}
        disableEsc={submitting}
        onClose={() => {
          if (submitting) return
          onClose()
        }}
      >
        <ModalHeader title='Approve eligible reimbursements' />
        <ModalBody padding='1.5rem 2rem'>
          <Text variant='body1'>
            Are you sure you want to approve eligible reimbursements?
          </Text>
        </ModalBody>
        <ModalFooter>
          <SecondaryButton onClick={onClose} disabled={submitting}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            style={{ marginLeft: '1rem' }}
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting ? 'Approving...' : 'Approve'}
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  ApproveEligibleReimbursementsModal.displayName =
    'ApproveEligibleReimbursementsModal'
}

export default ApproveEligibleReimbursementsModal
